import useAxios from "@hooks/use-axios";
import { useParams } from "react-router-dom";

const useFilters = () => {
    const { axiosInstance } = useAxios({ base: "panel" });
    const { platformId } = useParams();
    const getUserURL = (type = "", customURL = "") => {
        if (customURL) {
            return customURL;
        }
        if (type === "products") {
            return "/filters/products";
        }
        if (type === "user") {
            return "/filters/tags/user";
        }
        const url =
      ["sdr", "csm"].includes(type) ? `/user/${platformId}/filter/${type}` : `/filters/${platformId}/${type}`;
        return url;
    };
    const loadAsyncOptions = async ({
        value,
        callback,
        type = "",
        customURL = "",
        context = {},
        statusCheck = false
    }) => {
        const url = getUserURL(type, customURL);
        const { data } = await axiosInstance.get(url, {
            params: {
                ...(context ? { ...context } : {}),
                name: value
            }
        });

        const items = data;

        callback(
            items.map((item) => ({
                label: item.name || item.label,
                value: item._id || item.id,
                ...(item.content && { content: item.content }),
                ...(statusCheck && { isDisabled: item.status !== "active" && item.status }),
                ...(item.status && { status: item.status })
            }))
        );
    };

    return {
        loadAsyncOptions
    };
};

export default useFilters;
